// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';

import TreeItemDir from './TreeItemDir.jsx';
import App from './App.jsx';

import {noop, scroll} from './utils.js';

import {T_CULTI} from './codtype.js';
import type {T_Next, T_Item, T_Sen} from './types.js';
import type {TreeItem} from './TreeItem.js';



/* eslint-disable no-use-before-define */

export type T_OpenNextSen = (item_sen: ?TreeItemSen) => void;

/* eslint-enable no-use-before-define */


type T_TreeItemSenProps = {
  node       : T_Item,
  indent     : number,
  parent_item: TreeItemDir,
  disabled   : boolean,
  app        : App
};


type T_TreeItemSenState = {
  show_menu : boolean,
  hilight_fm: boolean,    // highlight para señalar que se hizo click derecho sobre el item
  Loaded    : boolean
};


export default class TreeItemSen extends Component<T_TreeItemSenProps, T_TreeItemSenState> implements TreeItem {
  click : (ev: SyntheticMouseEvent<*>) => void;
  rclick: (ev: SyntheticMouseEvent<*>) => void;



  constructor(props: T_TreeItemSenProps) {
    super(props);

    this.state = {
      show_menu : false,
      hilight_fm: false,
      Loaded    : false
    };

    this.click  = this.click.bind(this);
    this.rclick = this.rclick.bind(this);
  }



  open(next: T_Next = noop): void {
    if (this.state.Loaded) {
      return next(false);
    }
    

    const {app} = this.props,
          url   = `${app.remote}/get-json/?path=${this.props.node.Path}&session_id=${app.session()}`;
          
    fetch(url).then(resp => resp.json()).then((res: T_Sen) => {
      if (res.error && typeof res.error === 'string') {
        Alert.error(res);

        next(false);
      }
      else {
        app.setState({sen: res, node_path: this.props.node.Path}, () => {
          this.setState({Loaded: true}, () => {
            if (app.state.sen.alertas.length <= 1) {
              const 
                empty_alerta = {
                  id      :    -1,
                  nombre  :    '',
                  email   :    '',
                  temp_ref:     0,
                  temp_opt:    '',
                  hum_ref :     0,
                  hum_opt :    '',
                  estado  : false  
                },
                alertas = app.state.sen.alertas
              ;

              alertas.push(empty_alerta);
              
              app.setState(app.state.sen.alertas = alertas);

              next(true);
            } else {
              next(true);
            }
          });
        });
        
      }
    });
    
    if (app.state.sen != null && app.state.sen.path !== this.props.node.Path) {      
      const { path } = app.state.sen; 
      const item_sen = app.get_item_sen(path);
      
      if (item_sen != null) {
        item_sen.close();
      }
      app.setState({sen: null});
    }
    
    const item_culti = this.props.parent_item.shps.find(ishp => ishp.props.node.Cod === T_CULTI);
    
    if (item_culti && ! app.map_ui.map.is_loaded(item_culti.props.node.Path)) {
      if (item_culti != null) {
        item_culti.toggle(noop);
      }
    }
    else if (app.toolbar != null && item_culti != null && app.toolbar.state.culti !== item_culti.props.node.Path) {
      const culti = item_culti.props.node;
      
      this.props.app.map_ui.change_culti(culti.Path, noop, false, true);
    }
  }



  close(next: T_Next = noop): void {
    if (! this.state.Loaded) {
      return next(false);
    }

    const {app} = this.props;

    const end = () => {
      this.setState({Loaded: false}, () => next(true));
    };

    if (app.state.sen != null && app.state.sen.path === this.props.node.Path) {
      app.setState({sen: null}, end);
    }
    else {
      end();
    }
  }



  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }

    if (! this.state.Loaded) {
      this.open(next);
    }
    else {
      this.close(next);
    }
  }



  reload(next: T_Next = noop): void {    // NOTE: si no está cargado, lo abre.
    if (this.state.Loaded) {
      this.close(() => {
        this.open(next);
      });
    }
    else {
      this.open(next);
    }
  }



  click(ev: SyntheticMouseEvent<*>): void {
    ev.stopPropagation();

    if (ev.button === 0) {
      this.toggle();
    }
  }
  
  
  
  rclick(ev: SyntheticMouseEvent<*>): void {}
  
  
  
  refresh(next: T_Next = noop): void {
    const {app}  = this.props,
          Loaded = app.state.sen != null && app.state.sen.path === this.props.node.Path;
    if (Loaded !== this.state.Loaded) {
      this.setState({Loaded}, () => next(true));
    }
    else {
      next(false);
    }
  }



  scroll(): void {
    scroll(ReactDOM.findDOMNode(this));
  };



  get_path(): string {
    return this.props.node.Path;
  }



  get_file(): string {
    return this.props.node.File;
  }
  
  
  
  unclick(): void {
    if (this.state.Loaded) {
      this.setState({Loaded: false});
    }
  }



  render() {
    const {Loaded} = this.state,
          lb_style = {fontWeight: Loaded ? 'bold' : 'normal', border: '0', paddingRight: 0, paddingLeft: 0, color: 'black'},
          indent   = {marginLeft: 15 * this.props.indent};
    if (this.props.node.Unpub) {
      lb_style.color = 'red';
    }

    if (this.state.hilight_fm) {
      lb_style.border       = '1px solid red';
      lb_style.paddingRight = 3;
      lb_style.paddingLeft  = 3;
    }

    return (
      <div>
        <div className='treeItem' style={indent} onClick={this.click} onContextMenu={this.rclick}>
          <Icon
            name={
              this.props.node.Unpub && ! this.props.app.agrosat_user ?
                'frown-o'
              :
                (Loaded ? 'check-square-o' : 'square-o')
            }
          />

          <span style={lb_style}>
            {this.props.node.label}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemSen.jsx